import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Sidebar from './Sidebar';
import Header from './Header';
import { SET_MENU } from '../store/actions';
import { useTheme } from '@mui/material/styles';
import { drawerWidth } from '../store/constant';
import { AppBar, Box, Toolbar } from '@mui/material';
import { useState, useEffect } from 'react';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: -(drawerWidth - 20),
            padding: '10px',
            width: '100%'
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            width: '100%',
            padding: '10px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: '100%',
            padding: '10px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        padding: '10px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));

const MainLayout = () => {
    const theme = useTheme();
    const [showSidebar, setSidebar] = useState(false);
    const userInfo = JSON.parse(localStorage.getItem("qbarn.user"));
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };

    useEffect(() => {
        if (userInfo !== null &&  userInfo["uuid"].length > 0) {
            setSidebar(true);
        }else{
            setSidebar(false);
        }
    }, [userInfo]);

    return (
        <Box sx={{ display: 'flex' }}>
	        <AppBar
	        enableColorOnDark
	        position="fixed"
	        color="inherit"
	        elevation={0}
            sx={{
            	bgcolor: theme.palette.background.default,
                transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
            }}
	        >
	        	<Toolbar>
	          		<Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
	        	</Toolbar>
	    	</AppBar>
            {showSidebar && (<Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />)}
            <Main theme={theme} open={leftDrawerOpened}>
                <Outlet />
            </Main>
        </Box>
    );
};

export default MainLayout;